import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import SectionTitle from '../../components/SectionTitle';

import vec1 from '../../images/rsvp/flower1.png';
import vec2 from '../../images/rsvp/flower2.png';

import shape1 from '../../images/rsvp/shape1.png';
import shape2 from '../../images/rsvp/shape2.png';
import sentImg from '../../images/rsvp/sent-img.gif';
import Select from "react-select";
import { toast } from "react-toastify";
import { db, collection, addDoc } from "../../firebase"; // Ajusta la ruta si es necesario
import ClipLoader from 'react-spinners/ClipLoader';


const RSVP = (props) => {

    const [isLoading, setIsLoading] = useState(false);  // Estado para el loader
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);  // Estado para deshabilitar el botón


    const [forms, setForms] = useState({
        name: "",
        meal: null,
        intolerance: "",
        companionName: "",
        companionIntolerance: "",
        companionMeal: null,
        comment: ""
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage',
        messages: {
            required: 'Este campo es obligatorio.',
            alpha_space: 'Sólo se permiten letras y espacios.',
        }
    }));
    const [companions, setCompanions] = useState([]);
    const [accordionOpen, setAccordionOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const mealOptions = [
        { value: "infantil", label: "🍭 Infantil" },
        { value: "adulto", label: "🍗 Adulto" },
        { value: "adulto-vegano", label: "🥗 Adulto-Vegano" },
    ];

    const submitHandler = async (e) => {
        e.preventDefault();

        //Validar si hay acompañante a medias
        if (forms.companionName || forms.companionMeal != null || forms.companionIntolerance) {
            toast.error("No has acabado de añadir al acompañante. Presiona el botón de añadir", {
                position: "top-center", // Posición central superior
                autoClose: 3000, // Tiempo de duración (en milisegundos)
                hideProgressBar: true, // Mostrar barra de progreso
                closeOnClick: true, // Cierre al hacer clic
                pauseOnHover: true, // Pausa al pasar el cursor
                draggable: true, // Permitir arrastrar el toast
                progress: undefined, // Barra de progreso predeterminada
            });
            return;
        }
        if (validator.allValid()) {
            try {
                setIsLoading(true);  // Activamos el loader
                setIsSubmitDisabled(true);  // Deshabilitamos el botón

                // Guardar los datos en Firebase Firestore
                const docRef = await addDoc(collection(db, "RSVPs"), {
                    name: forms.name,
                    meal: forms.meal?.value || "",
                    intolerance: forms.intolerance || "",
                    comment: forms.comment || "",
                    companions: companions.map((companion) => ({
                        name: companion.name || "",
                        meal: companion.meal || "",
                        intolerance: companion.intolerance || "",
                    })),
                    timestamp: new Date(), // Fecha de envío
                });

                let people = [];

                people.push({
                    name: forms.name,
                    meal: forms.meal?.value || "",
                    intolerance: forms.intolerance || "",
                    comment: forms.comment || "",
                    companionFrom: null,
                    timestamp: new Date(), // Fecha de envío
                });

                people = people.concat(companions.map(companion => {
                    return {
                        name: companion.name,
                        meal: companion.meal || "",
                        intolerance: companion.intolerance || "",
                        comment: forms.comment || "",
                        companionFrom: docRef.id || "",
                        timestamp: new Date(), // Fecha de envío
                    }
                }));
                const promises = people.map(rsvp =>
                    addDoc(collection(db, "guests"), rsvp)
                );
                await Promise.all(promises); // Espera a que todas las promesas se resuelvan

                validator.hideMessages();
                setForms({
                    name: "",
                    meal: null,
                    intolerance: "",
                    companionName: "",
                    companionIntolerance: "",
                    companionMeal: null,
                    comment: "",
                });
                setCompanions([]);
                toast.success('¡Formulario enviado correctamente!', {
                    position: "top-center", // Posición central superior
                    autoClose: 3000, // Tiempo de duración (en milisegundos)
                    hideProgressBar: true, // Mostrar barra de progreso
                    closeOnClick: true, // Cierre al hacer clic
                    pauseOnHover: true, // Pausa al pasar el cursor
                    draggable: true, // Permitir arrastrar el toast
                    progress: undefined, // Barra de progreso predeterminada
                });
                setSuccessMessage('¡Formulario enviado correctamente!');


                // setTimeout(() => setSuccessMessage(""), 3000);
                const elemento = document.getElementById("RSVP");
                if (elemento) {
                    const posicion = elemento.getBoundingClientRect().top + window.scrollY; // Calcula la posición en la página
                    window.scrollTo({
                        top: posicion, // Aplica el offset restándolo
                        behavior: "smooth", // Desplazamiento suave
                    });
                }

                // setTimeout(() => {
                //     const elemento = document.getElementById("bus");
                //     if (elemento) {
                //         const posicion = elemento.getBoundingClientRect().top + window.scrollY; // Calcula la posición en la página
                //         window.scrollTo({
                //             top: posicion, // Aplica el offset restándolo
                //             behavior: "smooth", // Desplazamiento suave
                //         });
                //     }
                // }, 3000);
                // Desplazarse al elemento con id "campo-nombre"

            } catch (error) {
                toast.error('Ha habido un error en el envío', {
                    position: "top-center", // Posición central superior
                    autoClose: 3000, // Tiempo de duración (en milisegundos)
                    hideProgressBar: true, // Mostrar barra de progreso
                    closeOnClick: true, // Cierre al hacer clic
                    pauseOnHover: true, // Pausa al pasar el cursor
                    draggable: true, // Permitir arrastrar el toast
                    progress: undefined, // Barra de progreso predeterminada
                });
            } finally {
                setIsLoading(false);  // Desactivamos el loader
                setIsSubmitDisabled(false);  // Habilitamos el botón nuevamente
            }
        } else {
            validator.showMessages();
            setForms({ ...forms })
            setSuccessMessage("");
        }
    };

    const changeHandler = (name, value) => {
        setForms({ ...forms, [name]: value });

        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const handleAddCompanion = () => {
        if (forms.companionName && forms.companionMeal) {
            setCompanions([
                ...companions,
                { name: forms.companionName, meal: forms.companionMeal.value, intolerance: forms.companionIntolerance },
            ]);
            setForms({ ...forms, companionName: "", companionIntolerance: "", companionMeal: null });
            toast.success('Acompañante añadido correctamente', {
                position: "top-center", // Posición central superior
                autoClose: 3000, // Tiempo de duración (en milisegundos)
                hideProgressBar: true, // Mostrar barra de progreso
                closeOnClick: true, // Cierre al hacer clic
                pauseOnHover: true, // Pausa al pasar el cursor
                draggable: true, // Permitir arrastrar el toast
                progress: undefined, // Barra de progreso predeterminada
            });
        } else {
            toast.error('Por favor, complete todos los campos del acompañante.', {
                position: "top-center", // Posición central superior
                autoClose: 3000, // Tiempo de duración (en milisegundos)
                hideProgressBar: true, // Mostrar barra de progreso
                closeOnClick: true, // Cierre al hacer clic
                pauseOnHover: true, // Pausa al pasar el cursor
                draggable: true, // Permitir arrastrar el toast
                progress: undefined, // Barra de progreso predeterminada
            });
        }
    };

    const handleRemoveCompanion = (indexToRemove) => {
        setCompanions(companions.filter((_, index) => index !== indexToRemove));
        toast.info('Acompañante eliminado', {
            position: "top-center", // Posición central superior
            autoClose: 3000, // Tiempo de duración (en milisegundos)
            hideProgressBar: true, // Mostrar barra de progreso
            closeOnClick: true, // Cierre al hacer clic
            pauseOnHover: true, // Pausa al pasar el cursor
            draggable: true, // Permitir arrastrar el toast
            progress: undefined, // Barra de progreso predeterminada
        });
    };

    return (
        <section className={`wpo-contact-section ${props.pt}`} id="RSVP">
            {/* Mostrar el loader mientras isLoading sea verdadero */}
            {isLoading && (
                <div className="loader-overlay">
                    <ClipLoader color="#fff" loading={isLoading} size={50} />
                </div>
            )}
            <div className="container">
                <div className="wpo-contact-section-wrapper">
                    <div className="wpo-contact-form-area">
                        {successMessage ? (
                            <div className="success-message" style={{ display: 'grid' }}>
                                <h2 className='col-10 mx-auto' style={{ textAlign: 'center', paddingTop: '3rem' }}>{successMessage}</h2>
                                <p className='text-center'>¡Aún hay más!<br></br> Desliza para abajo y no te pierdas nada.</p>
                                <img style={{ height: '20rem', padding: '1rem', textAlign: 'center', margin: 'auto' }} src={sentImg} alt="" />
                            </div>
                        ) : (
                            <div>
                                <SectionTitle MainTitle={'¿Te unes a nuestra celebración?'} />

                                <form onSubmit={(e) => submitHandler(e)} className="contact-validation-active">
                                    <div className="form-field">
                                        <input
                                            value={forms.name}
                                            type="text"
                                            name="name"
                                            onChange={(e) => changeHandler("name", e.target.value)}
                                            className="form-control"
                                            placeholder="Nombre y apellidos"
                                        />
                                        {validator.message("name", forms.name, "required")}
                                    </div>

                                    {/* Menú */}
                                    <div className="form-field">
                                        <label>¿Qué menú querrás?</label>
                                        <Select
                                            options={mealOptions}
                                            value={forms.meal}
                                            onChange={(selectedOption) => changeHandler("meal", selectedOption)}
                                            placeholder="Seleccione un menú"
                                            className="form-control no-border"
                                        />
                                        {validator.message("meal", forms.meal, "required")}
                                    </div>

                                    {/* Intolerancias */}
                                    <div className="form-field">
                                        <label>¿Alguna intolerancia o alergia?</label>
                                        <input
                                            value={forms.intolerance}
                                            type="text"
                                            name="intolerance"
                                            onChange={(e) => changeHandler("intolerance", e.target.value)}
                                            className="form-control"
                                            placeholder=""
                                        />
                                        {validator.message("intolerance", forms.name, "")}
                                    </div>

                                    {/* Acordeón para acompañantes */}
                                    <div className="form-field">
                                        {!accordionOpen && (<button
                                            type="button"
                                            style={{ zIndex: 0, width: '100%' }}
                                            onClick={() => setAccordionOpen(!accordionOpen)}
                                            className="theme-btn show-companions-btn"
                                        >
                                            + Añadir Acompañantes
                                        </button>)}

                                        {accordionOpen && (
                                            <div className="accordion-content">
                                                <h4>Acompañantes:</h4>
                                                <div className="form-field card p-2 m-2 shadow-sm">
                                                    <input
                                                        value={forms.companionName}
                                                        type="text"
                                                        name="companionName"
                                                        onChange={(e) => changeHandler("companionName", e.target.value)}
                                                        className="form-control"
                                                        placeholder="Nombre y apellidos"
                                                    />
                                                    <input
                                                        value={forms.companionIntolerance}
                                                        type="text"
                                                        name="companionIntolerance"
                                                        onChange={(e) => changeHandler("companionIntolerance", e.target.value)}
                                                        className="form-control"
                                                        placeholder="Intolerancia o alergia"
                                                    />
                                                    <Select
                                                        options={mealOptions}
                                                        value={forms.companionMeal}
                                                        onChange={(selectedOption) =>
                                                            changeHandler("companionMeal", selectedOption)
                                                        }
                                                        placeholder="Tipo de menú"
                                                        className="form-control no-border"
                                                    />
                                                    <button
                                                        type="button"
                                                        style={{ zIndex: 0, width: '100%', backgroundColor: 'black' }}
                                                        onClick={handleAddCompanion}
                                                        className="theme-btn"
                                                    >
                                                        + Añadir
                                                    </button>
                                                </div>

                                            </div>
                                        )}
                                    </div>

                                    {/* Lista de acompañantes */}
                                    {companions.length > 0 && (
                                        <div className="form-field" style={{
                                            borderBottom: '1px solid #D9D9D9',
                                            paddingBottom: '40px'
                                        }}>
                                            <ul>
                                                {companions.map((companion, index) => (
                                                    <li key={index} style={{ display: 'flex' }}>
                                                        <div style={{ width: '80%' }}>
                                                            {companion.name} - {companion.meal}
                                                            {companion.intolerance && (
                                                                <div>
                                                                    <span>({companion.intolerance})</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <button
                                                            class="theme-btn my-1"
                                                            onClick={() => handleRemoveCompanion(index)}
                                                            style={{
                                                                zIndex: 0,
                                                                width: '20%',
                                                                marginLeft: '10px',
                                                                cursor: 'pointer',
                                                                backgroundColor: 'red',
                                                                padding: '6px',
                                                                borderRadius: '15px'
                                                            }}
                                                        >
                                                            Eliminar
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>)}

                                    {/* Asistencia */}
                                    <div className="form-field">
                                        <label>Comentarios adicionales:</label>
                                        <textarea
                                            id="textarea"
                                            value={forms.comment}
                                            type="text"
                                            style={{ height: '4em' }}
                                            name="comment"
                                            onChange={(e) => changeHandler("comment", e.target.value)}
                                            className="form-control"
                                        />
                                    </div>

                                    {/* Enviar */}
                                    <div className="submit-area">
                                        <button style={{ fontSize: '2rem', borderRadius: '15px' }} type="submit" disabled={isSubmitDisabled} className="theme-btn">
                                            Enviar
                                        </button>
                                    </div>

                                </form>
                            </div>
                        )}
                    </div>
                    <div className="vector-1">
                        <img src={vec1} alt="" />
                    </div>
                    <div className="vector-2">
                        <img src={vec2} alt="" />
                    </div>
                </div>
            </div>
            <div className="shape-1">
                <img src={shape1} alt="" style={{filter: 'grayscale(1)'}} />
            </div>
            <div className="shape-2">
                <img src={shape2} alt="" style={{filter: 'grayscale(1)'}} />
            </div>
        </section>
    );
};

export default RSVP;
